/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const changeIncidentCustomerBodyVersionExclusiveMin = 0;
export const changeIncidentCustomerBodyVersionMax = 9007199254740991;

export const changeIncidentCustomerBodyCustomerIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);

export const ChangeIncidentCustomerBody = zod.object({
  version: zod
    .int()
    .gt(changeIncidentCustomerBodyVersionExclusiveMin)
    .max(changeIncidentCustomerBodyVersionMax),
  customerId: zod.uuid().regex(changeIncidentCustomerBodyCustomerIdRegExp),
});

export type ChangeIncidentCustomerBody = zod.input<typeof ChangeIncidentCustomerBody>;
export type ChangeIncidentCustomerBodyOutput = zod.output<typeof ChangeIncidentCustomerBody>;
